import { useQuery } from '@tanstack/react-query';
import { awaitJSON, MiscLambdaFetch, SheetsLambdaFetch } from '@src/utils/fetch-utils';
import { ShopifyAccountRow, ShopifyInstallLink } from './shopify-connections-constants';

const loadAllShopifyAccounts = async (): Promise<ShopifyAccountRow[]> => {
  const res = await MiscLambdaFetch('/getAllShopifyAccounts');
  return awaitJSON<ShopifyAccountRow[]>(res);
};

export const useAllShopifyAccounts = () =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['allShopifyAccounts'],
    queryFn: loadAllShopifyAccounts
  });

const loadCompanyIds = async (): Promise<string[]> => {
  const res = await SheetsLambdaFetch('/get_company_ids');
  const { ids } = await awaitJSON<{ ids: string[] }>(res);
  return ids;
};

export const useCompanyIds = () =>
  useQuery({ queryKey: ['shopifyCompanyIds'], queryFn: loadCompanyIds, staleTime: Infinity });

// Mints a signed install link for the client to open in their own Shopify admin. The OAuth
// callback is handled entirely by the lambda, so nothing here navigates to the link.
export const beginShopifyInstall = async (
  company: string,
  store: string
): Promise<ShopifyInstallLink> => {
  const res = await MiscLambdaFetch('/beginShopifyInstall', { params: { company, store } });
  return awaitJSON<ShopifyInstallLink>(res);
};
